import { Building2, FlaskConical, Layers, User, type LucideIcon } from "lucide-react";
import type { OrganizationType } from "@bookdental/schemas";

export type OrgTypeMeta = { label: string; icon: LucideIcon; color: string };

/** Identidade visual por natureza da organização — mesmas cores que os tipos de parceiro já usam
 *  (clínica azul brand, laboratório sky), pra tela de Organizações e afins não inventarem uma
 *  paleta própria. */
export function orgTypeMeta(org: { isPersonal: boolean; types: OrganizationType[] }): OrgTypeMeta {
  if (org.isPersonal) return { label: "Pessoal", icon: User, color: "#71717a" };
  const lab = org.types.includes("DENTAL_LAB");
  const office = org.types.includes("DENTAL_OFFICE");
  if (lab && office) return { label: "Híbrida", icon: Layers, color: "#7c3aed" };
  if (lab) return { label: "Laboratório", icon: FlaskConical, color: "#0ea5e9" };
  if (office) return { label: "Clínica", icon: Building2, color: "#2457FF" };
  return { label: "Organização", icon: Building2, color: "#71717a" };
}
